import React from "react";
import { Grid, Typography } from "@mui/material";

export default function officeProvidersHeader() {

    return {
        setHeaderCellProps: () => ({
            sx:{
                backgroundColor: 'primary.main',
                position: 'sticky',
                top: 0,
                left: 0,
                zIndex: '160 !important',
                border: 0,
            }}),
        render: () => <Grid container sx={{ minWidth: 210 }} >
            <Grid item xs={12} sx={{ height: '2rem', pb: 1 }} />
            <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start'}}>
                <Typography sx={{ fontWeight: 'bold' }}>Branch</Typography>
            </Grid>
            <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start'}}>
                <Typography sx={{ fontWeight: 'bold' }}>Providers</Typography>
            </Grid>
        </Grid>
    }
}